module.exports = {"320505001":"横塘街道","320505002":"狮山街道","320505003":"枫桥街道","320505004":"镇湖街道","320505005":"东渚街道","320505100":"浒墅关镇","320505101":"通安镇","320505400":"浒墅关经济技术开发区","320505405":"苏州高新技术创业服务中心","320505407":"苏州科技城","320505408":"苏州高新区综合保税区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320505.json
// module id = 865
// module chunks = 0